module.exports = __webpack_public_path__ + "img/share-icon.0a878cbc.svg";